import { isSet } from '../utils/isSet';
import { Accordion } from "../classes/Accordion";
import EmblaCarousel from 'embla-carousel';
import { addDotBtnsAndClickHandlers } from '../functions/emblaCarouselPagination';
import { setupLazyLoadImage } from '../functions/emblaCarouselLazyLoad';
import ClassNames from 'embla-carousel-class-names';


class MediaContent {
    constructor (domNode) {
        this.domNode = domNode;
        this.embla = this.domNode.querySelector('.embla--js');
        this.accordion = this.domNode.querySelector('.media-content__accordion--js');

        this.init();
    }

    init(){
        if(isSet(this.embla)){
            this.init__embla();
        }

        if(isSet(this.accordion)){
            this.init__accordion();
        }
    }

    init__embla(){
        this.emblaViewportNode = this.embla.querySelector('.embla__viewport');
        if(!isSet(this.emblaViewportNode)) return;

        this.emblaSlideNodes = this.embla.querySelectorAll('.embla__slide');
        if(!isSet(this.emblaSlideNodes) || this.emblaSlideNodes.length === 0) return;

        this.emblaDotsNode = this.embla.querySelector('.embla__pagination');

        this.emblaOptions = {}

        this.emblaApi = EmblaCarousel(
            this.emblaViewportNode, 
            this.emblaOptions,
            []
        );

        if(isSet(this.emblaDotsNode)){
            const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
                this.emblaApi,
                this.emblaDotsNode
            );

            this.emblaApi.on('destroy', removeDotBtnsAndClickHandlers);
        }

        const loadImagesInView = setupLazyLoadImage(this.emblaApi);

        this.emblaApi
            .on('init', loadImagesInView)
            .on('reInit', loadImagesInView)
            .on('slidesInView', loadImagesInView)
    }

    init__accordion(){
        this.accordionApi = new Accordion(
            this.accordion,
            {
                collapsible:true,
                type: 'single'
            }
        );
        this.onAccordionOpenBound = this.onAccordionOpen.bind(this);

        this.accordionApi.triggers.forEach( (trigger) => {
            trigger.addEventListener('click', this.onAccordionOpenBound);
        })
    }

    onAccordionOpen(e){
        if(!isSet(e.target)) return;

        if(e.target.getAttribute('aria-expanded') === 'true' && e.target.dataset.linkedIndex){

            if(e.target.dataset.linkedIndex >= this.emblaSlideNodes.length) return;

            this.emblaApi.scrollTo(parseInt(e.target.dataset.linkedIndex));
        }
    }
}

exports.MediaContent = MediaContent